import { configureStore } from '@reduxjs/toolkit';
import dashboardSlice from './reducer/dashboardSlice';

export const store = configureStore({
  reducer: {
    dashboard: dashboardSlice,
  }
});
